export default __webpack_public_path__ + "static/media/rocket_anim_147.5b5fa3c8.png";